"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifeQuality = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const LifeQuality_style_1 = require("./LifeQuality.style");
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
const atome_1 = require("../../../atome");
const organisms_1 = require("../../../organisms");
const User_service_1 = __importDefault(require("../../../../services/User.service"));
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const InputLoader_1 = __importDefault(require("../../../atome/InputLoader/InputLoader"));
// @ts-ignore
function LifeQuality({ navigation }) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const dispatch = (0, hooks_1.useAppDispatch)();
    const [mood, setMood] = (0, react_1.useState)(0);
    const [joyOfLife, setJoyOfLife] = (0, react_1.useState)(0);
    const [generalActivity, setGeneralActivity] = (0, react_1.useState)(0);
    const [appetite, setAppetite] = (0, react_1.useState)(0);
    const [sexuality, setSexuality] = (0, react_1.useState)(0);
    const [everydayWork, setEverydayWork] = (0, react_1.useState)(0);
    const [concentration, setConcentration] = (0, react_1.useState)(0);
    const [sleep, setSleep] = (0, react_1.useState)(0);
    const [saveSuccess, setSaveSuccess] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [isSaving, setSaving] = (0, react_1.useState)(false);
    const save = async () => {
        const lifeQuality = userInformation?.lifeQuality;
        const data = {
            lifeQuality: [
                {
                    id: lifeQuality && lifeQuality.length > 0
                        ? lifeQuality[0].id
                        : undefined,
                    mood: mood === 0 ? 11 : mood,
                    joyOfLife: joyOfLife === 0 ? 11 : joyOfLife,
                    generalActivity: generalActivity === 0 ? 11 : generalActivity,
                    appetite: appetite === 0 ? 11 : appetite,
                    sexuality: sexuality === 0 ? 11 : sexuality,
                    everydayWork: everydayWork === 0 ? 11 : everydayWork,
                    concentration: concentration === 0 ? 11 : concentration,
                    sleep: sleep === 0 ? 11 : sleep,
                    queryDate: new Date().toString(),
                },
            ],
        };
        setSaving(true);
        const response = await User_service_1.default.update(data);
        setSaving(false);
        if (response.error) {
            console.error(response.message);
        }
        if (!response.error) {
            const newUserInformation = {
                ...userInformation,
                lifeQuality: { ...userInformation?.lifeQuality, ...data.lifeQuality },
            };
            dispatch((0, reducers_1.setUserInformation)(newUserInformation));
            setSaveSuccess(true);
            setTimeout(() => {
                setSaveSuccess(false);
                navigation.navigate('CaseHistoryOverview');
            }, 2000);
        }
    };
    // TODO[PD] - Auslagern -> HelperService weil mehrmals
    const getUserInformation = async () => {
        const information = userInformation;
        (0, reducers_1.setUserInformation)(information);
        if (information.lifeQuality && information.lifeQuality.length > 0) {
            if (information.lifeQuality[0].mood) {
                setMood(Number(information.lifeQuality[0].mood));
            }
            if (information.lifeQuality[0].joyOfLife) {
                setJoyOfLife(Number(information.lifeQuality[0].joyOfLife));
            }
            if (information.lifeQuality[0].generalActivity) {
                setGeneralActivity(Number(information.lifeQuality[0].generalActivity));
            }
            if (information.lifeQuality[0].appetite) {
                setAppetite(Number(information.lifeQuality[0].appetite));
            }
            if (information.lifeQuality[0].sexuality) {
                setSexuality(Number(information.lifeQuality[0].sexuality));
            }
            if (information.lifeQuality[0].everydayWork) {
                setEverydayWork(Number(information.lifeQuality[0].everydayWork));
            }
            if (information.lifeQuality[0].concentration) {
                setConcentration(Number(information.lifeQuality[0].concentration));
            }
            if (information.lifeQuality[0].sleep) {
                setSleep(Number(information.lifeQuality[0].sleep));
            }
        }
    };
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', async () => {
            setLoading(true);
            if (userInformation.id) {
                await getUserInformation();
                setLoading(false);
            }
        });
    }, []);
    (0, react_1.useEffect)(() => {
        (async () => {
            await getUserInformation();
            setLoading(false);
        })();
    }, [userInformation]);
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, { style: LifeQuality_style_1.styles.backgroundColor },
            react_1.default.createElement(react_native_1.ScrollView, { style: [LifeQuality_style_1.styles.backgroundColor] },
                Breakpoints_1.isDesktop && react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
                react_1.default.createElement(react_native_1.View, { style: [
                        LifeQuality_style_1.styles.container,
                        react_native_1.Platform.OS === 'web' && LifeQuality_style_1.styles.marginVertical20,
                    ] },
                    react_1.default.createElement(react_native_1.View, { style: [
                            !Breakpoints_1.isDesktop && LifeQuality_style_1.styles.marginHorizontal30,
                            Breakpoints_1.isMobile
                                ? [GlobalStyles_1.globalStyles.marginTop35, GlobalStyles_1.globalStyles.marginBottom15]
                                : GlobalStyles_1.globalStyles.marginBottom40,
                        ] },
                        Breakpoints_1.isDesktop && (react_1.default.createElement(atome_1.Text, { style: [LifeQuality_style_1.styles.heading2] }, "Lebensqualit\u00E4t")),
                        react_1.default.createElement(atome_1.Text, { style: [LifeQuality_style_1.styles.heading2] }, "Wie geht es Ihnen heute?"),
                        react_1.default.createElement(atome_1.Label, { style: [LifeQuality_style_1.styles.lineHeight20] }, "Wie sch\u00E4tzen Sie die folgenden Bereiche Ihres t\u00E4glichen Lebens auf einer Skala von 0 (sehr schlecht) bis 10 (sehr gut) ein?")),
                    react_1.default.createElement(react_native_1.View, { style: [!Breakpoints_1.isDesktop && LifeQuality_style_1.styles.marginHorizontal30] },
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column,
                                GlobalStyles_1.globalStyles.marginRow,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [LifeQuality_style_1.styles.questionLabel, LifeQuality_style_1.styles.lifeQualityLabel] }, "Stimmung"),
                            react_1.default.createElement(atome_1.Slider, { style: [LifeQuality_style_1.styles.slider, LifeQuality_style_1.styles.marginHorizontalSlider], value: mood, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, disabled: userInformation?.progress.isDataConfirm, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setMood(value) })),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column,
                                GlobalStyles_1.globalStyles.marginRow,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [LifeQuality_style_1.styles.questionLabel, LifeQuality_style_1.styles.lifeQualityLabel] }, "Lebensfreude"),
                            react_1.default.createElement(atome_1.Slider, { style: [LifeQuality_style_1.styles.slider, LifeQuality_style_1.styles.marginHorizontalSlider], value: joyOfLife, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, disabled: userInformation?.progress.isDataConfirm, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setJoyOfLife(value) })),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column,
                                GlobalStyles_1.globalStyles.marginRow,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [
                                    LifeQuality_style_1.styles.questionLabel,
                                    LifeQuality_style_1.styles.lifeQualityLabel,
                                    LifeQuality_style_1.styles.lineHeight20,
                                ] }, "Allgemeine Aktivit\u00E4t / k\u00F6rperliche Belastbarkeit"),
                            react_1.default.createElement(atome_1.Slider, { style: [LifeQuality_style_1.styles.slider, LifeQuality_style_1.styles.marginHorizontalSlider], value: generalActivity, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, disabled: userInformation?.progress.isDataConfirm, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setGeneralActivity(value) })),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column,
                                GlobalStyles_1.globalStyles.marginRow,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [LifeQuality_style_1.styles.questionLabel, LifeQuality_style_1.styles.lifeQualityLabel] }, "Appetit"),
                            react_1.default.createElement(atome_1.Slider, { style: [LifeQuality_style_1.styles.slider, LifeQuality_style_1.styles.marginHorizontalSlider], value: appetite, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, disabled: userInformation?.progress.isDataConfirm, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setAppetite(value) })),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column,
                                GlobalStyles_1.globalStyles.marginRow,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [LifeQuality_style_1.styles.questionLabel, LifeQuality_style_1.styles.lifeQualityLabel] }, "Sexualit\u00E4t"),
                            react_1.default.createElement(atome_1.Slider, { style: [LifeQuality_style_1.styles.slider, LifeQuality_style_1.styles.marginHorizontalSlider], value: sexuality, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, disabled: userInformation?.progress.isDataConfirm, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setSexuality(value) })),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column,
                                GlobalStyles_1.globalStyles.marginRow,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [LifeQuality_style_1.styles.questionLabel, LifeQuality_style_1.styles.lifeQualityLabel] }, "Beruf / Allt\u00E4gliche Arbeit"),
                            react_1.default.createElement(atome_1.Slider, { style: [LifeQuality_style_1.styles.slider, LifeQuality_style_1.styles.marginHorizontalSlider], value: everydayWork, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, disabled: userInformation?.progress.isDataConfirm, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setEverydayWork(value) })),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column,
                                GlobalStyles_1.globalStyles.marginRow,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [LifeQuality_style_1.styles.questionLabel, LifeQuality_style_1.styles.lifeQualityLabel] }, "Geistige T\u00E4tigkeiten / Konzentration"),
                            react_1.default.createElement(atome_1.Slider, { style: [LifeQuality_style_1.styles.slider, LifeQuality_style_1.styles.marginHorizontalSlider], value: concentration, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, disabled: userInformation?.progress.isDataConfirm, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setConcentration(value) })),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column,
                                GlobalStyles_1.globalStyles.marginRow,
                            ] },
                            react_1.default.createElement(atome_1.Label, { style: [LifeQuality_style_1.styles.questionLabel, LifeQuality_style_1.styles.lifeQualityLabel] }, "Schlaf"),
                            react_1.default.createElement(atome_1.Slider, { style: [LifeQuality_style_1.styles.slider, LifeQuality_style_1.styles.marginHorizontalSlider], value: sleep, minimumValue: 0, maximumValue: 10, showScale: true, step: 1, disabled: userInformation?.progress.isDataConfirm, thumbTintColor: "#3db384", minimumTrackTintColor: "#c2c2c2", maximumTrackTintColor: "#c2c2c2", onValueChange: value => setSleep(value) })),
                        !Breakpoints_1.isDesktop && (react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.marginTop25] },
                            saveSuccess && (react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.column,
                                    LifeQuality_style_1.styles.saveMessageContainer,
                                ] },
                                react_1.default.createElement(atome_1.Text, { style: [LifeQuality_style_1.styles.saveMessageText] }, "Speichern erfolgreich"))),
                            react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, LifeQuality_style_1.styles.alignSelfCenter] },
                                !userInformation?.progress.isDataConfirm && (react_1.default.createElement(react_native_1.View, { style: [
                                        GlobalStyles_1.globalStyles.marginRow,
                                        LifeQuality_style_1.styles.buttonContainer,
                                    ] },
                                    react_1.default.createElement(react_native_1.Pressable, { style: LifeQuality_style_1.styles.button, onPress: save },
                                        react_1.default.createElement(atome_1.Text, { style: [LifeQuality_style_1.styles.buttonText] }, "Speichern")))),
                                userInformation?.progress.isDataConfirm && (react_1.default.createElement(react_native_1.View, { style: [
                                        GlobalStyles_1.globalStyles.marginRow,
                                        LifeQuality_style_1.styles.buttonContainer,
                                    ] },
                                    react_1.default.createElement(react_native_1.Pressable, { style: LifeQuality_style_1.styles.button, onPress: () => {
                                            navigation.navigate('CaseHistoryOverview');
                                        } },
                                        react_1.default.createElement(atome_1.Text, { style: [LifeQuality_style_1.styles.buttonText] }, "Zur \u00DCbersicht"))))))),
                        Breakpoints_1.isDesktop && (react_1.default.createElement(react_1.default.Fragment, null,
                            saveSuccess && (react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.column,
                                    LifeQuality_style_1.styles.saveMessageContainer,
                                ] },
                                react_1.default.createElement(atome_1.Text, { style: [LifeQuality_style_1.styles.saveMessageText] }, "Speichern erfolgreich"))),
                            !userInformation?.progress.isDataConfirm && (react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.row,
                                    GlobalStyles_1.globalStyles.marginRow,
                                    LifeQuality_style_1.styles.buttonContainer,
                                ] },
                                react_1.default.createElement(react_native_1.Pressable, { pointerEvents: isSaving ? 'none' : 'auto', style: [
                                        isSaving ? LifeQuality_style_1.styles.buttonLoading : LifeQuality_style_1.styles.button,
                                        GlobalStyles_1.globalStyles.saveButtonContainer,
                                    ], onPress: save },
                                    isSaving ? react_1.default.createElement(InputLoader_1.default, null) : null,
                                    react_1.default.createElement(atome_1.Text, { style: [LifeQuality_style_1.styles.buttonText] }, "Speichern")))),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.row,
                                    GlobalStyles_1.globalStyles.marginRow,
                                    LifeQuality_style_1.styles.buttonContainer,
                                ] },
                                react_1.default.createElement(react_native_1.Pressable, { onPress: () => navigation.navigate('CaseHistoryOverview') },
                                    react_1.default.createElement(atome_1.Text, { style: [LifeQuality_style_1.styles.backButtonText] }, "\u2190 Zur\u00FCck")))))))))));
}
exports.LifeQuality = LifeQuality;
